import { useContext } from 'react';
import { NotificationContext } from 'components';
import { ErrorMappingValueType } from 'typings';

export const useNotificationApi = () => {
  const notificationApi = useContext(NotificationContext);

  // Ensure notificationApi is not null before using it
  if (!notificationApi) {
    throw new Error('useNotificationApi must be used within a NotificationContext.Provider');
  }

  return (messageContent: ErrorMappingValueType) => {
    const { type, message, ...rest } = messageContent;
    notificationApi[type]({
      message: message,
      ...rest,
    });
  };
};
